import { Component, inject } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { LABELS } from '../../../../commons/constants/labels.constant';
import { RouterStates } from '../../../../commons/constants/router-states.constant';
import { MobileService } from '../../../../commons/services/mobile.service';
import { EQueryStringParams, LocalStorageService } from '../../../../commons/stores/local-storage.service';
import { StoreService } from '../../../../commons/stores/store.service';
import { AppService } from '../../services/app.service';
import { TvLoginStore } from '../../services/app.store';

@Component({
  selector: 'tvl-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  translationLoadedForTheFirstTime = inject(TvLoginStore).translationLoadedForTheFirstTime;
  protected readonly LABELS = LABELS;

  title = 'app';
  footerLogoStyle$: Observable<any>;
  loginBodyStyle$: Observable<any>;
  appVersion: any;
  showTrueViewSubtitle = false;

  constructor(
    private readonly storeService: StoreService,
    private readonly localStorageService: LocalStorageService,
    public readonly service: AppService,
    public readonly router: Router,
    private readonly _mobileService: MobileService
  ) {
    this.footerLogoStyle$ = this.service
      .getFooterLogoStyle$()
      .pipe(map((styles) => (styles && !!Object.keys(styles).length ? styles : null)));
    this.loginBodyStyle$ = this.service.getLoginBodyStyle$();
    this.appVersion = this.localStorageService.getQueryParamFromLocalStorage(EQueryStringParams.appVer);
    this.showTrueViewSubtitle = this._mobileService.isMobileApp();
  }

  isShowSelectSystemLanguage() {
    const matchOptions: IsActiveMatchOptions = {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    };

    return !this.router.isActive(RouterStates.selectLanguage, matchOptions);
  }

  isClient() {
    return this.storeService.isClientDefined();
  }

  isClientLabeling(): boolean {
    const isClientLabeling = this.isClient() && this.isShowSelectSystemLanguage();
    // show client labels only if client is defined
    // except select language page, there the default labels should be shown:  this.isShowSelectSystemLanguage() === false

    return isClientLabeling;
  }
}
